import React__default, { useMemo } from 'react';
import { Spinner } from '@vp/swan';
import { WranglerDataContext, ManagedWranglerSelectionsContext } from '@vp/wrangler-data-source';
import { ResponseButtons as ResponseButtons$1 } from './ResponseButtons.mjs';
import { ConfiguratorLayout } from './ConfiguratorLayout/ConfiguratorLayout.mjs';
import { useConfiguratorContext } from '../contexts/configuratorContext/useConfiguratorContext.mjs';
import { ConfiguratorContextProvider } from '../contexts/configuratorContext/configuratorContextProvider.mjs';
import LoggingProvider from '../providers/logging/loggingProvider.mjs';

const ContextAwareConfigurator = ({ uiLabelOverrides, hideOptionImages, priceDisplayMode = "differential-unit", hideOptionDescriptions, showIncompatibleChoices, onCancel, onSaveSelections, onPriceUpdated, onErrorClear, renderingOverrides, allOptionsRequired, showFormErrors, onValidation, loader, }) => {
    const ResponseButtonsComponent = useMemo(() => () => {
        return React__default.createElement(ResponseButtons, { onSaveSelections: onSaveSelections, onCancel: onCancel, responseButtons: renderingOverrides?.responseButtons });
    }, [renderingOverrides]);
    const Layout = useMemo(() => {
        if (renderingOverrides?.configuratorLayout) {
            return renderingOverrides.configuratorLayout;
        }
        return ConfiguratorLayout;
    }, [renderingOverrides?.configuratorLayout]);
    const wranglerData = React__default.useContext(WranglerDataContext);
    const managedWranglerSelections = React__default.useContext(ManagedWranglerSelectionsContext);
    const [errors, setErrors] = React__default.useState([]);
    if (wranglerData?.exceptionMessages?.length > 0) {
        // If we've got errors, and the set of errors is different from the last time, fire the onError handler.
        if (JSON.stringify(wranglerData.exceptionMessages) !== JSON.stringify(errors)) {
            LoggingProvider.error("Received errors from wrangler call", undefined, {
                errorMessages: wranglerData.exceptionMessages
            });
            setErrors(wranglerData.exceptionMessages);
        }
    }
    if (errors.length > 0 && wranglerData?.exceptionMessages?.length === 0) {
        // If we had errors before, but now there are none, then fire onErrorClear.
        onErrorClear?.();
        setErrors([]);
    }
    if (!wranglerData?.data || !managedWranglerSelections) {
        if (loader) {
            return loader;
        }
        return React__default.createElement(Spinner, { accessibleText: '...' }); // TODO : consider localized accessibleText !?
    }
    return (React__default.createElement(ConfiguratorContextProvider, { allOptionsRequired: allOptionsRequired, onPriceUpdated: onPriceUpdated, uiLabelOverrides: uiLabelOverrides, showFormErrors: showFormErrors, onValidation: onValidation },
        React__default.createElement(Layout, { priceDisplayMode: priceDisplayMode, responseButtons: ResponseButtonsComponent, hideOptionImages: hideOptionImages, hideOptionDescriptions: hideOptionDescriptions, showIncompatibleChoices: showIncompatibleChoices })));
};
const ResponseButtons = ({ onSaveSelections, onCancel, responseButtons }) => {
    const ResponseButtonsComponent = useMemo(() => {
        return responseButtons ?? ResponseButtons$1;
    }, [responseButtons]);
    const { priceInfo, mpvId, productName, uiLabels, selectedQuantity, isLoading, selections, document } = useConfiguratorContext();
    const currentPrice = priceInfo?.quantities?.find((q) => q.quantity === selectedQuantity);
    const saveContext = {
        mpvId: mpvId,
        productName: productName,
        price: currentPrice,
    };
    return (React__default.createElement(ResponseButtonsComponent, { onSaveSelections: () => !isLoading &&
            selections &&
            onSaveSelections(selections, selectedQuantity, document, saveContext), onCancel: onCancel, saveChangesLabel: uiLabels.saveChanges, revertChangesLabel: uiLabels.revertChanges, selectPreviewLabel: uiLabels.selectPreview }));
};

export { ContextAwareConfigurator };
//# sourceMappingURL=ContextAwareConfigurator.mjs.map
